module.exports = __webpack_public_path__ + "601ba654cab61e166c005967dbb39f5d.svg";